import React, { useMemo } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import ErrorPage from '@/components/errors/ErrorPage';
import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import Jumbotron from '@/components/ui/box/Jumbotron';
import Panel from '@/components/ui/box/Panel';
import Paper from '@/components/ui/box/Paper';
import Loading from '@/components/ui/loading/Loading';
import { pageTitles } from '@/constants/pageTitles';
import useCurrentUser from '@/hooks/store/useCurrentUser';

import InviteEmailInputForm from './InviteEmailInputForm';
import styles from './InviteEmailInputPage.module.scss';

type LocationState = {
  email?: string;
};

const InviteEmailInputPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { code } = useParams<{ code: string }>();
  const [currentUser] = useCurrentUser();
  const state = location.state as LocationState | null;
  const initialEmail = state?.email;

  const student = useMemo(() => {
    if (!code || !currentUser) {
      return null;
    }
    return (
      currentUser.organization_memberships.find((s) => s.code === code) ?? null
    );
  }, [code, currentUser]);

  const handleBack = () => {
    navigate('/mypage/profile');
  };

  if (!currentUser) {
    return (
      <SingleColumnTemplate>
        <div className={styles.InviteEmailInputPage}>
          <Jumbotron>
            <Paper>
              <Panel title={pageTitles.inviteEmailInput} strongHeader>
                <Loading />
              </Panel>
            </Paper>
          </Jumbotron>
        </div>
      </SingleColumnTemplate>
    );
  }

  if (!code || !student) {
    return <ErrorPage type="not_found" />;
  }

  return (
    <SingleColumnTemplate>
      <div className={styles.InviteEmailInputPage}>
        <Jumbotron>
          <Paper>
            <Panel title={pageTitles.inviteEmailInput} strongHeader>
              <InviteEmailInputForm
                student={student}
                code={code}
                initialEmail={initialEmail}
                onBack={handleBack}
              />
            </Panel>
          </Paper>
        </Jumbotron>
      </div>
    </SingleColumnTemplate>
  );
};

export default InviteEmailInputPage;
